"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotlistUnit = void 0;
exports.getHotlistUnit = getHotlistUnit;
var HotlistUnit;
(function (HotlistUnit) {
    HotlistUnit[HotlistUnit["Percent"] = 0] = "Percent";
    HotlistUnit[HotlistUnit["Shares"] = 1] = "Shares";
    HotlistUnit[HotlistUnit["Currency"] = 2] = "Currency";
    HotlistUnit[HotlistUnit["Ratio"] = 3] = "Ratio";
})(HotlistUnit || (exports.HotlistUnit = HotlistUnit = {}));
function getHotlistUnit(value) {
    switch (value) {
        case 'percent':
            return HotlistUnit.Percent;
        case 'shares':
            return HotlistUnit.Shares;
        case 'currency':
            return HotlistUnit.Currency;
        default:
            return HotlistUnit.Ratio;
    }
}
//# sourceMappingURL=HotlistUnit.js.map